import Vue from 'vue';
import Vuex from 'vuex';
import moment from 'moment';
import Amplify, * as AmplifyModules from 'aws-amplify';
import { API, graphqlOperation } from 'aws-amplify';
import { AmplifyPlugin } from 'aws-amplify-vue';
import * as queries from '@/graphql/queries';

import awsExports from './aws-exports';
import App from './App.vue';
import router from './router';
import vuetify from './plugins/vuetify';

Amplify.configure(awsExports);
Vue.use(AmplifyPlugin, AmplifyModules);

Vue.use(Vuex);
const store = new Vuex.Store({
  state: {
    details: null,
    statusItems: [],
    priorityItems: [],
  },
  mutations: {
    fetchDetails: async (state, groupId) => {
      API.graphql(graphqlOperation(queries.getClient, {
        id: groupId,
      })).then((response) => {
        state.details = JSON.parse(JSON.stringify(response.data.getClient));
      }).catch((err) => console.log(err));
    },
    fetchStatusItems: async (state) => {
      const response = await API.graphql(graphqlOperation(queries.listJobStatuss, {
        limit: 100,
      }));
      state.statusItems = JSON.parse(JSON.stringify(
        response.data.listJobStatuss.items,
      ));
    },
    fetchPriorityItems: async (state) => {
      const response = await API.graphql(graphqlOperation(queries.listJobPrioritys, {
        limit: 100,
      }));
      state.priorityItems = JSON.parse(JSON.stringify(
        response.data.listJobPrioritys.items,
      ));
    },
  },
});

Vue.prototype.moment = moment;

Vue.mixin({
  methods: {
    dateFormat(date) {
      return date ? this.moment(date).format('D MMM Y') : null;
    },
  },
});

new Vue({
  router,
  vuetify,
  store,
  render: (h) => h(App),
}).$mount('#app');
